import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSiteContext } from '../context/SiteContext';

const MaintenanceNotification = () => {
    const navigate = useNavigate();
    const { maintenanceMode, setMaintenanceMode } = useSiteContext();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // Check if user is authenticated (for admin toggle)
    useEffect(() => {
        const user = localStorage.getItem('user');
        const token = localStorage.getItem('token');
        setIsAuthenticated(!!(user && token));
    }, []);

    const handleGoHome = () => {
        navigate('/dashboard');
    };

    const handleToggleMaintenance = () => {
        setMaintenanceMode(!maintenanceMode);
        if (maintenanceMode) {
            // If turning off maintenance, redirect to dashboard if authenticated, otherwise to login
            const user = localStorage.getItem('user');
            const token = localStorage.getItem('token');
            if (user && token) {
                navigate('/dashboard');
            } else {
                navigate('/login');
            }
        }
    };

    return (
        <div className="bg-[linear-gradient(to_top,_#38275B_0%,_#251A3C_33.33333333333333%,_#140E20_66.66666666666666%,_#000000_100%)] min-h-screen max-h-screen relative overflow-hidden flex items-center justify-center p-4">
            {/* Main content */}
            <div className="relative z-10 text-center px-4 max-w-2xl mx-auto w-full">
                {/* Logo */}
                <div className="mb-8 flex justify-center">
                    <img
                        src="/logo.svg"
                        alt="R-Link Logo"
                        className="h-12 sm:h-16 md:h-20 w-auto object-contain"
                    />
                </div>

                {/* Title */}
                <div className="mb-6">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
                        Scheduled Maintenance Alert
                    </h1>
                    <div className="w-24 sm:w-32 md:w-40 h-1 bg-gradient-to-r from-yellow-500 to-orange-500 mx-auto rounded-full"></div>
                </div>

                {/* Message */}
                <div className="mb-8">
                    <p className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed mb-4">
                        R-Link will be temporarily unavailable on <span className="font-semibold text-white">Sunday, Nov 16 from 11:30 AM – 1:30 PM ET</span> while we perform routine maintenance.
                    </p>
                    <p className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed">
                        Everything will be back online right after the window. Thanks for your patience <span className="text-green-400">❤️</span>
                    </p>
                </div>

                {/* Maintenance Image */}
                <div className="mt-6 flex justify-center">
                    <img
                        src="/maintenancetime.jpeg"
                        alt="Maintenance Alert"
                        className="max-w-full h-auto rounded-lg shadow-lg max-h-[300px] sm:max-h-[400px] md:max-h-[500px] object-contain"
                    />
                </div>
            </div>
        </div>
    );
};

export default MaintenanceNotification;

